import React from 'react';

import reducer, { initialState } from './reducer';
import {
  setToken,
  signIn,
  signOut,
  signUp,
  onAuthStateChanged,
  stopLoading,
  resetPassword,
  sendPasswordReset,
  updateEmail,
} from './actions';
import { IAuthContext } from './types';
import { AUTH_TOKEN_KEY } from './constants';

const initialContext: IAuthContext = {
  ...initialState,
  resetPassword: (code: string, password: string) => {},
  updateEmail: (email: string) => {},
  sendPasswordReset: (email: string) => {},
  signIn: (email: string, password: string) => {},
  signUp: (email: string, password: string) => {},
  signOut: () => {},
  stopLoading: () => {},
};
export const AuthContext = React.createContext(initialContext);

const AuthProvider: React.FC = ({ children }) => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  React.useEffect(() => {
    const localToken = localStorage.getItem(AUTH_TOKEN_KEY);
    setToken(dispatch, localToken || '');
    onAuthStateChanged(dispatch);
  }, []);

  return (
    <AuthContext.Provider
      value={{
        ...state,
        resetPassword: (code: string, password: string) => resetPassword(dispatch, code, password),
        updateEmail: (email: string) => updateEmail(dispatch, email),
        sendPasswordReset: (email: string) => sendPasswordReset(dispatch, email),
        signIn: (email: string, password: string) => signIn(dispatch, email, password),
        signUp: (email: string, password: string) => signUp(dispatch, email, password),
        signOut: () => signOut(dispatch),
        stopLoading: () => stopLoading(dispatch),
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
